

































































































import Vue from "vue";
// import HeaderComponent from "@/components/HeaderComponent.vue";
import ApiService from "@/services/ApiService";
import ActionsHistory from "@/components/admin/ActionsHistory.vue";
export default Vue.extend({
  name: "SingleStudent",
  props: {
    studentId: Number,
  },
  components: {
    ActionsHistory,
  },
  data() {
    return {
      student: {},
      editYear: false,
      newYear: 0,
      options: [
        { value: -1, label: "Nursery" },
        { value: 0, label: "Reception" },
        { value: 1, label: "Year 1" },
        { value: 2, label: "Year 2" },
        { value: 3, label: "Year 3" },
        { value: 4, label: "Year 4" },
        { value: 5, label: "Year 5" },
        { value: 6, label: "Year 6" },
        { value: 7, label: "Year 7" },
        { value: 8, label: "Year 8" },
        { value: 9, label: "Year 9" },
        { value: 10, label: "Year 10" },
        { value: 11, label: "Year 11" },
      ],
      activeTab: "student",
    };
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab);
    },
    changeStudentYear(year) {
      ApiService.sadminApi
        .changeStudentYear({ year: year, student_id: this.student.info.id })
        .then(() => {
          this.$message({
            showClose: true,
            message: "Year Changed!",
            type: "success",
          });
          this.editYear = false;
          this.loadUser();
        });
    },
    action(type, id) {
      if (type === "delete_user_device") {
        ApiService.sadminApi
          .deleteAction({ type: "delete_user_device", id: id })
          .then(() => {
            this.$message({
              showClose: true,
              message: "Deleted!",
              type: "success",
            });

            // this.loadUser();
          });
      } else if (type === "delete_student_journey") {
        ApiService.sadminApi
          .deleteAction({ type: "delete_student_journey", id: id })
          .then(() => {
            this.$message({
              showClose: true,
              message: "Deleted!",
              type: "success",
            });
            this.loadUser();
          });
      } else if (type === "delete_student") {
        ApiService.sadminApi
          .deleteAction({ student_id: this.student.info.id })
          .then(() => {
            this.$message({
              showClose: true,
              message: "Deleted!",
              type: "success",
            });
            this.$emit("close");
          });
      } else if (type === "remove_student") {
        ApiService.sadminApi
          .removeStudentFromSchool({ student_id: this.student.info.id })
          .then(() => {
            this.$message({
              showClose: true,
              message: "Removed!",
              type: "success",
            });
            this.$emit("close");
          });
      }
    },
    loadUser() {
      ApiService.generalApi
        .getParentOrStudent({ student_id: this.studentId })
        .then((resp) => {
          if (resp.data.student) {
            this.student = resp.data.student;
            this.newYear = this.student.current_year;
            this.options = resp.data.student.available_years.reverse();
          }
        });
    },
    yearsConversion(year) {
      let yearLabel = "";
      switch (year) {
        case -3:
          yearLabel += "EY1";
          break;
        case -2:
          yearLabel += "EY2";
          break;
        case -1:
          yearLabel += "N";
          break;
        case 0:
          yearLabel += "R";
          break;

        default:
          yearLabel = year;
          break;
      }
      return yearLabel;
    },
  },
  computed: {
    accType: function () {
      return this.$store.state.accType;
    },
  },
  mounted() {
    this.loadUser();
    // this.$store.dispatch("logout", true);
  },
});
